import React, { useState } from 'react';
import { ManageServices } from './manage_services';
import { ManageBankDetails } from './manage_bank_details';

export const SettingsAdmin = () => {
    const [selectedTab, setSelectedTab] = useState('services'); // 'services' or 'bank'

    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                padding: '20px 42px',
                borderBottom: '1px solid #eee',
                backgroundColor: 'white'
            }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                    <div
                        onClick={() => setSelectedTab('services')}
                        style={{
                            cursor: 'pointer',
                            padding: '10px 15px',
                            borderBottom: selectedTab === 'services' ? '3px solid #3765A5' : '3px solid transparent',
                            color: selectedTab === 'services' ? '#3765A5' : '#666',
                            fontWeight: selectedTab === 'services' ? '600' : '400'
                        }}
                    >
                        Manage Services
                    </div>
                    <div
                        onClick={() => setSelectedTab('bank')}
                        style={{
                            cursor: 'pointer',
                            padding: '10px 15px',
                            borderBottom: selectedTab === 'bank' ? '3px solid #3765A5' : '3px solid transparent',
                            color: selectedTab === 'bank' ? '#3765A5' : '#666',
                            fontWeight: selectedTab === 'bank' ? '600' : '400'
                        }}
                    >
                        Manage Bank Details
                    </div>
                </div>
            </div>

            <div style={{ flex: 1, overflowY: 'auto' }}>
                {selectedTab === 'services' && <ManageServices />}
                {selectedTab === 'bank' && <ManageBankDetails />}
            </div>
        </div>
    );
};
